"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "mongardino": {
    "ed05ef27": [{
      "hkey": "e3307d5f",
      "slug": "mongardino",
      "name": "Mongardino",
      "primary": true,
      "skipSearch": false
    }],
    "adchieri": [{
      "hkey": "e3307d5f",
      "slug": "mongardino",
      "name": "Mongardino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5eda3fb9": [{
      "hkey": "6712471c",
      "slug": "san-pietro-stazione",
      "name": "San Pietro Stazione",
      "primary": true,
      "skipSearch": false
    }],
    "stazione": [{
      "hkey": "6712471c",
      "slug": "san-pietro-stazione",
      "name": "San Pietro Stazione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7ca49368": [{
      "hkey": "50992c69",
      "slug": "terpore-serra-d-asti",
      "name": "Terpore-Serra d'Asti",
      "primary": true,
      "skipSearch": false
    }],
    "terpone": [{
      "hkey": "50992c69",
      "slug": "terpore-serra-d-asti",
      "name": "Terpore-Serra d'Asti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;